import { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import apiClient from "utils/apiClient";
import { getAuthToken } from "utils/authToken";

const UnitSystemContext = createContext();

export function UnitSystemProvider({ children }) {
  const [metric, setMetricState] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!getAuthToken()) {
      setLoaded(true);
      return;
    }
    apiClient
      .get("/api/users/me/preferences")
      .then((res) => {
        setMetricState(res.data.unit_system === "metric");
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const setMetric = (valueOrUpdater) => {
    setMetricState((prev) => {
      const next = typeof valueOrUpdater === "function" ? valueOrUpdater(prev) : valueOrUpdater;
      apiClient
        .patch("/api/users/me/preferences", { unit_system: next ? "metric" : "us" })
        .catch(() => {});
      return next;
    });
  };

  return (
    <UnitSystemContext.Provider value={{ metric, setMetric, loaded }}>
      {children}
    </UnitSystemContext.Provider>
  );
}

UnitSystemProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useUnitSystem() {
  return useContext(UnitSystemContext);
}
